import {
  FETCH_PURCHASE_ORDER,
  RESET_PURCHASE_ORDER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const purchaseOrderViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_ORDER:
      return { data: action.payload };
    case RESET_PURCHASE_ORDER:
      return initialState;
    default:
      return state;
  }
};

export default purchaseOrderViewReducer;
